// Com "showAllCategories": true no config.json, o mapa abre com todas as
// categorias do menu à mostra. Clicar numa categoria isola ela; clicar de novo
// na mesma volta a mostrar todas. As categorias "fixed" ficam sempre visíveis.

const menuIds = (categories) =>
  Object.keys(categories).filter((key) => categories[key].onMenu);

export function initialCategories(config) {
  const { categories } = config;
  if (!config.showAllCategories) return categories;

  const all = { ...categories };
  menuIds(categories).forEach((key) => {
    all[key] = { ...categories[key], active: true };
  });
  return all;
}

export function isolateCategory(categories, id) {
  const ids = menuIds(categories);
  const active = ids.filter((key) => categories[key].active);
  const alreadyIsolated = active.length === 1 && active[0] === String(id);

  const next = { ...categories };
  ids.forEach((key) => {
    next[key] = {
      ...categories[key],
      active: alreadyIsolated || key === String(id),
    };
  });
  return next;
}
